module.exports = __webpack_public_path__ + "static/Rebecca_round-a3a38bf08a489d12341c3fc8eca211ba.png";